import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTables: builder.mutation({
      query: (body) => {
        // console.log(body);
        return {
          url: "/connectpg/showTables",
          method: "POST",
          body: body,
        };
      },
    }),
    saveDataSource: builder.mutation({
      query: (body) => ({
        url: "/connectpg/saveDataSource",
        method: "POST",
        body: body,
      }),
    }),

    getLatestDraft: builder.query({
      query: () => ({
        url: "/workbookapi/latest-drafts",
        method: "GET",
      }),
    }),
    //connect pg databasetype
    connectPostgresql: builder.mutation({
      query: (formData) => {
        // console.log(formData);
        return {
          url: "/modelling/getschemas_sqlalchemy",
          method: "POST",
          body: formData,
        };
      },
    }),
    //get table column name
    getPostgresqlTablesColumndata: builder.mutation({
      query: ({ connectionId, tableName }) => {
        // // console.log(connectionId, tableName);
        return {
          url: "/modelling/getcolumns_sqlalchemy",
          method: "POST",
          body: {
            connectionId,
            tableName,
          },
        };
      },
    }),
    //get previewdata
    getPostgresqlTablesPreviewdata: builder.mutation({
      query: ({ connectionId, tableName }) => {
        // // console.log(connectionId, tableName);
        return {
          url: "/modelling/getpreview_sqlalchemy",
          method: "POST",
          body: {
            connectionId,
            tableName,
          },
        };
      },
    }),
    //rename table in pg
    getsaveTempdataPostgresqlTablename: builder.mutation({
      query: (body) => ({
        url: "/modelling/getrenametable_sqlalchemy",
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useGetTablesMutation,
  useSaveDataSourceMutation,
  useGetLatestDraftQuery,
  useConnectPostgresqlMutation,
  useGetPostgresqlTablesColumndataMutation,
  useGetPostgresqlTablesPreviewdataMutation,
  useGetsaveTempdataPostgresqlTablenameMutation,

} = sqlApiSlice;
